import React from 'react';
import { gql } from '@apollo/client';
import { useMutation } from 'hooks/apollo';
import { FormattedMessage, useIntl } from 'react-intl';
import SurveyGroupSelect from 'components/SurveyGroupSelect';

import { Form } from 'antd';
import useGlobalContext from 'hooks/useGlobalContext';
import messages from './messages';

const MUTATION = gql`
  mutation ($targetSurveyId: ID!, $targetBlockId: ID!, $sourceSurveyId: ID!) {
    importSurvey(targetSurveyId: $targetSurveyId, targetBlockId: $targetBlockId, sourceSurveyId: $sourceSurveyId)
  }
`;

const ImportContentForm = ({
  form, onSubmit, onDone,
  customerId, surveyId, targetBlockId,
}) => {
  const { formatMessage: $t } = useIntl();
  const { message } = useGlobalContext();
  const [importContent] = useMutation(MUTATION);

  const onFinish = async (values) => {
    const sourceSurveyId = values.survey;
    try {
      onSubmit();
      await importContent({ variables: { targetSurveyId: surveyId, targetBlockId, sourceSurveyId } });
      message.success($t(messages.importSuccess));
      onDone();
    } catch (error) {
      message.error($t(messages.importFail));
    }
  };

  return (
    <Form layout="vertical" onFinish={onFinish} form={form}>
      <Form.Item
        name="survey"
        label={<FormattedMessage {...messages.survey} />}
        rules={[{ required: true, message: $t(messages.surveyRequired) }]}
      >
        <SurveyGroupSelect
          customerId={customerId}
          exclude={[surveyId]}
          selectables={['survey']}
        />
      </Form.Item>
    </Form>
  );
};

export default ImportContentForm;
